import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import ApiClient from '../api/ApiClient';
import TerminalGrid from '../components/device/TerminalGrid';
import DeviceInfoGrid from '../components/device/DeviceInfoGrid';
import Header from '../layout/Header';
import Breadcrumb from '../layout/Breadcrumb';
import { getDeviceRequest } from '../reducers/devices';

const styles = theme => ({
  main: {
    flexGrow: 1,
    padding: theme.spacing(0, 2, 2, 2)
  },
  terminal: {
    width: 830,
    overflowX: 'auto'
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 320
  },
  listInfo: {
    minWidth: 350
  }
});

class Device extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: '',
      comment: '',
      colors: [],
      printTemplates: [],
      printTemplateGroups: [],
      roles: [],
      product_lines: [],
      brands: [],
      cases: [],
      powers: [],
      hws: [],
      model_types: [],
      isPrintDialogOpen: false,
      sku: []
    };
    this.setState = this.setState.bind(this);
  }

  getLists = () => {
    const setState = this.setState;

    ApiClient.fetchJson(`devices/lists/`, 'GET', {}, function(response) {
      setState({
        colors: response.colors,
        printTemplates: response.print_templates,
        printTemplateGroups: response.print_template_groups,
        product_lines: response.product_lines,
        roles: response.roles,
        brands: response.brands,
        cases: response.cases,
        powers: response.powers,
        hws: response.hws,
        model_types: response.model_types
      });
    });
  };

  getSku = () => {
    const setState = this.setState;
    ApiClient.fetchJson(`devices/sku/?device_id=${this.props.match.params.id}`, 'GET', {}, function(response) {
      setState({
        sku: response,
      });
    });
  };

  componentDidMount() {
    getDeviceRequest(this.props.match.params.id);
    this.getLists();
    this.getSku();
  }

  componentWillUnmount() {
    console.log('closing websocket connection...');
    this.props.terminalSocket.close();
  }

  render() {
    const {
      classes,
      match,
      token,
      device,
      deviceInfo,
      dispatch,
      isDeviceInitialized,
      terminalSocket
    } = this.props;

    const { colors, printTemplates, printTemplateGroups, sku, product_lines, roles, brands, cases, powers, hws, model_types } = this.state;

    return (
      <React.Fragment>
        <Header />
        <Breadcrumb>
          <Typography color="textPrimary">Device {match.params.id}</Typography>
        </Breadcrumb>
        {device ? (
          <>
            <main className={classes.main}>
              <Grid container spacing={2}>
                <DeviceInfoGrid
                  device={device}
                  deviceInfo={deviceInfo}
                  classes={classes}
                  colors={colors}
                  deviceId={match.params.id}
                  dispatch={dispatch}
                  printTemplates={printTemplates}
                  printTemplateGroups={printTemplateGroups}
                  sku={sku}
                  productLines={product_lines}
                  roles={roles}
                  brands={brands}
                  cases={cases}
                  powers={powers}
                  hws={hws}
                  modelTypes={model_types}
                  refreshSku={this.getSku}
                />
                <TerminalGrid
                  deviceId={match.params.id}
                  classes={classes}
                  dispatch={dispatch}
                  token={token}
                  isDeviceInitialized={isDeviceInitialized}
                  terminalSocket={terminalSocket}
                />
              </Grid>
            </main>
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

Device.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  socket: state.auth.socket,
  terminalSocket: state.devices.socket,
  token: state.auth.accessToken,
  device: state.devices.currentDevice,
  deviceInfo: state.devices.currentDeviceInfo,
  isDeviceInitialized: state.devices.isDeviceInitialized
});

export default connect(mapStateToProps)(withStyles(styles)(Device));
